module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-Exeter-d3186c5f58d97c529a254490579bf77b.svg";